module.exports = {
	"config": {
		"siteTitle": "Blog by Tyler Riedal",
		"siteDescr": "Full-stack developer.<br>Security enthusiast.",
		"siteAuthor": "Tyler Riedal",
		"siteGithubUrl": "https://github.com/triedal",
		"siteEmailUrl": "mailto:triedal@mail.usf.edu?Subject=Hello",
		"googleAnalyticsId": "",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/tylerriedal/Code/blog/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/tylerriedal/Code/blog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-07-narnia-walkthrough",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-07-narnia-walkthrough",
				"stem": "index",
				"path": "articles/2017-01-07-narnia-walkthrough/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/articles/2017-01-07-narnia-walkthrough/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-01-07-narnia-walkthrough/index.md",
			"path": "/narnia-writeup/",
			"data": {
				"title": "OverTheWire Narnia Writeup",
				"date": "2017-01-07T23:51:47+00:00",
				"layout": "post",
				"path": "/narnia-writeup/",
				"category": "security",
				"description": "Writeup on how to complete OverTheWire's Naria wargame. This wargame focuses on beginner binary exploitations."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-08-building-a-spam-filter",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-08-building-a-spam-filter",
				"stem": "index",
				"path": "articles/2017-01-08-building-a-spam-filter/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/articles/2017-01-08-building-a-spam-filter/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-01-08-building-a-spam-filter/index.md",
			"path": "/spam-filter/",
			"data": {
				"title": "Building a Spam Filter",
				"date": "2017-01-08T23:51:47+00:00",
				"layout": "post",
				"path": "/spam-filter/",
				"category": "natural language processing",
				"description": "Tutorial on how to build a spam filter using Python and NLTK."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-10-bootloader",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-10-bootloader",
				"stem": "index",
				"path": "articles/2017-01-10-bootloader/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/articles/2017-01-10-bootloader/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-01-10-bootloader/index.md",
			"path": "/ryo-bootloader/",
			"data": {
				"title": "Roll Your Own: Bootloader Edition",
				"date": "2017-01-10T23:51:47+00:00",
				"layout": "post",
				"path": "/ryo-bootloader/",
				"category": "os dev",
				"description": "How to build a simple bootloader with assembly."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-03-14-compiling-linux-kernel",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-03-14-compiling-linux-kernel",
				"stem": "index",
				"path": "articles/2017-03-14-compiling-linux-kernel/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/articles/2017-03-14-compiling-linux-kernel/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-03-14-compiling-linux-kernel/index.md",
			"path": "/compile-linux-kernel/",
			"data": {
				"title": "Compiling The Vanilla Linux Kernel",
				"date": "2017-03-14T23:51:47+00:00",
				"layout": "post",
				"path": "/compile-linux-kernel/",
				"category": "os dev",
				"description": "Guide to building the Linux kernel."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-22-rootkit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-22-rootkit",
				"stem": "index",
				"path": "articles/2017-04-22-rootkit/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/articles/2017-04-22-rootkit/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-04-22-rootkit/index.md",
			"path": "/rootkit-poc/",
			"data": {
				"title": "Subverting the Linux Kernel for Fun and Profit",
				"date": "2017-04-22T23:51:47+00:00",
				"layout": "post",
				"path": "/rootkit-poc/",
				"category": "security",
				"description": "Demonstration of a simple rootkit developed for the 2.6.x Linux kernel."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/tylerriedal/Code/blog/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/pages/about/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/books",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/books",
				"stem": "index",
				"path": "pages/books/index.md",
				"absolute": "/Users/tylerriedal/Code/blog/pages/books/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/books/index.md",
			"path": "/books/",
			"data": {
				"title": "Books",
				"layout": "page",
				"path": "/books"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0